import View from '@/components/common/view'
import TraineeEmployerIndex from '../components/traineeEmployer/Index';
import TraineeEmployerImportPerson from '../components/traineeEmployer/detail/ImportPerson';
import TraineeEmployerImportPersonNotRe from '../components/traineeEmployer/detail/ImportPersonNotRe';
import TraineeEmployerPolicyDetail from '../components/traineeEmployer/detail/Policy';
import TraineeEmployerSettleDetail from '../components/traineeEmployer/detail/SettleDetails';

export default [
	{
		path:'',
		component:TraineeEmployerIndex,
	},
	{
		path:'import-person/:id',
		component:TraineeEmployerImportPerson,
	},
	{
		path:'import-person-not/:id',
		component:TraineeEmployerImportPersonNotRe,
	},
	{
		path:'policy-detail/:id',
		component:TraineeEmployerPolicyDetail,
	},
	{
		path:'settle-detail/:id',
		component:TraineeEmployerSettleDetail,
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/traineeEmployer.js